/* eslint-disable @typescript-eslint/no-unused-vars */
import { Loading } from '@/components';

import { useGetFeatureFlagAsync } from './apis';

type WithFeatureFlagProps = {
  featureFlagKey: string;
};

export function WithFeatureFlagForPage<T extends WithFeatureFlagProps = WithFeatureFlagProps>(
  WrappedComponent: React.ComponentType<T>,
) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const ComponentWithFeatureFlag = (props: WithFeatureFlagProps) => {
    const { featureFlagKey } = props;
    const { data: isEnabled, isLoading: isGetFeatureFlagLoading } = useGetFeatureFlagAsync({
      featureFlagKey,
    });

    if (isGetFeatureFlagLoading) {
      return <Loading />;
    }

    // return <>{isEnabled ? <WrappedComponent {...(props as T)} /> : <Navigate to='/404' />}</>;
    return <WrappedComponent {...(props as T)} />;
  };

  ComponentWithFeatureFlag.displayName = `withFeatureFlag(${displayName})`;

  return ComponentWithFeatureFlag;
}
